import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Student360Service } from '../student360.service';
import { Portal } from '../../shared-components/portal.model';
import { LoginService } from '../../shared-modules/login/login.service';
import { StudentService } from '../../shared-components/student/student.service';
import { Student } from '../../shared-components/student/student.model';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../shared-components/shared.service';
import { UserService } from '../../shared-components/user/user.service';
import { YearService } from '../../shared-components/year/year.service';
import { NavigationExtras, Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { StudentSummaryService } from './student-summary.service';
import { SettingsMenuModalComponent } from './settings-menu-modal/settings-menu-modal.component';
import { CardContainerComponent } from './card-container/card-container.component';
import { Enrollment } from '../../shared-components/student/enrollment.model';
import { WelcomeModalComponent } from './welcome-modal/welcome-modal.component';
import { UserPreferencesService } from '../../shared-components/user-preferences/user-preferences.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { OnlinePaymentConfiguration } from '../online-payment/models/online-payment-config.model';
import { NewAnnouncementsModalComponent } from './new-announcements-modal/new-announcements-modal.component';
import { AnnouncementService } from '../../shared-modules/announcement/announcement.service';
import { EFormService } from '../../shared-components/e-forms/e-form.service';
import { OnlineRegistrationService } from '../online-registration/online-registration.service';
import { MultipleFamiliesComponent } from '../online-registration/student-update/multiple-families/multiple-families.component';
import { SecurityService } from '../../shared-components/security/security.service';
import { PermissionEnum } from '../../shared-components/security/permissions.enums';
import { StudentDocuments } from '../../shared-components/student/student-documents.model';
import { NotificationsService } from '../../admin360/notifications/notifications.service';
import { CheckInOutSubmissionRequestModalComponent } from './check-in-out-submission-request-modal/check-in-out-submission-request-modal.component';
import { CheckInOutSubmissionRequest } from './check-in-out-submission-request-modal/check-in-out-submission-request-modal.model';
import { AbsentNotice } from '../../admin360/attendance-administration/review-absent-notices/absent-notice.model';
import { AbsentNoticeSubmissionModalComponent } from './absent-notice-submission-modal/absent-notice-submission-modal.component';

@AutoUnsubscribe({
    includeArrays: true
})
@Component({
    selector: 'studentSummary',
    templateUrl: './student-summary.component.html',
    styleUrls: ['./student-summary.component.css']
})
export class StudentSummaryComponent implements OnInit, AfterViewInit, OnDestroy {

    selectedStudent: Student;
    studentEnrollment: Enrollment;
    onlineRegistrationStatus = '';
    subscriptions: Subscription[] = [];
    recentDisciplineEvents: any;
    recentHealthEvents: any;
    unmarkedOptionalEFormsEvents: boolean;
    userType: number;
    @ViewChild(CardContainerComponent, { static: true }) cardContainer: CardContainerComponent;
    parentAssignedPortalsSubscription: Subscription;
    staffAssignedPortalsSubscription: Subscription;
    displayORHeadline: boolean;
    displayCourseRequestHeadline = false;
    onlinePaymentConfiguration: OnlinePaymentConfiguration = new OnlinePaymentConfiguration();
    requiredEFormAvailable: number;
    optionalEFormAvailable: number;
    eFormsActivated: boolean;
    defaultAcademicYear: boolean;
    optionalInstanceIds = '';
    studentDocumentIds = '';
    recentOptionalEFormEvents: any;
    eFormHeadLinePermission = false;
    requiredORYear = '';
    portals: Portal[] = [];

    studentDocuments: StudentDocuments[];
    behaviorlatterStudentDocuments = false;
    attendancelatterStudentDocuments = false;

    displayBehaviorLetterHeadline = false;
    recentBehaviorLetters: any;

    enableCheckInOut = false;
    enableAbsentNotice = false;
    checkInOutSubmissionRequest: CheckInOutSubmissionRequest;

    constructor(
        private studentService: StudentService,
        private router: Router,
        private loginService: LoginService,
        private userService: UserService,
        private sharedService: SharedService,
        private yearService: YearService,
        private dialog: MatDialog,
        private ref: ChangeDetectorRef,
        private classroom360Service: Classroom360Service,
        private student360Service: Student360Service,
        private studentSummaryService: StudentSummaryService,
        private userPreferencesService: UserPreferencesService,
        private announcementService: AnnouncementService,
        private eFormService: EFormService,
        private onlineRegService: OnlineRegistrationService,
        private securityService: SecurityService,
        private notificationsService: NotificationsService
    ) {
    }


    ngOnInit() {
        this.userType = this.userService.userType;
        this.subscriptions.push(this.yearService.observableStudent360YearStream$.subscribe(student360Year => {
            this.getOnlineRegistrationStatus();
            this.cardContainer.refreshCards();
        }));
        this.subscriptions.push(this.studentService.observableStudentEnrollmentStream$.subscribe(enrollment => {
            if (enrollment) {
                this.loadStudentInfo(enrollment.StudentId);
                // Check for New Announcements
                if (this.userService.currentUser.UserType != 1) {
                    this.getAnnouncements();
                    this.getCheckInOutButtnSettings(enrollment.StudentId, enrollment.AcademicYearID);
                }
                this.getCourseRequestStatus();
                this.getBehaviorLetterEvents();
            } else {
                this.enableCheckInOut = false;
                this.enableAbsentNotice = false;
            }
        }));
        this.getOnlinePaymentConfiguration();
        if (this.userService.userType == 1) { // If Staff
            this.subscriptions.push(this.staffAssignedPortalsSubscription = this.classroom360Service.observableStaffAssignedPortalsStream$
                .subscribe(portals => {
                    if (portals.length > 0) {
                        this.portals = portals.filter(portal => !portal.Deleted);
                        this.selectedStudent = this.studentService.selectedStudent;
                        this.checkPortals(this.portals);
                    }
                }));
        } else { // If Parent or Student
            this.subscriptions.push(this.parentAssignedPortalsSubscription = this.student360Service.observableParentAssignedPortalsStream$
                .subscribe(portals => {
                    if (portals.length > 0) {
                        this.portals = portals.filter(portal => !portal.Deleted);
                        this.selectedStudent = this.studentService.selectedStudent;
                        this.checkPortals(this.portals);
                        this.checkEFormAvailable();
                        this.getStudentDocuments();
                    }
                    this.defaultAcademicYear = ((this.yearService.student360Year.Status == 1) || (this.yearService.student360Year.Status == 2)) ? false : true;
                }));
        }
        this.getAnnouncementsPopup();
        this.getOnlineRegistrationStatus();
        // Checking student broadcasts
        this.announcementService.checkBroadcast();
        this.notificationsService.setNotificationChecking();
        this.subscriptions.push(this.eFormService.observableeFormHeadLinePermissionStream$.subscribe(fieldsExist => {
            this.eFormHeadLinePermission = this.eFormService.eFormHeadLinePermission;
        }));

    }

    private getBehaviorLetterEvents() {
        const that = this;
        this.displayBehaviorLetterHeadline = false;
        this.studentSummaryService.getStudentRecentEvents(this.selectedStudent.Id, this.userService.currentUser.MemberId, this.yearService.student360Year.Id, this.optionalInstanceIds).subscribe(response => {
            if (response.ok) {
                that.recentBehaviorLetters = response.body.filter(rde => rde.Type == 'BehaviorLetter')[0];
                if (that.recentBehaviorLetters && that.recentBehaviorLetters.Count > 0) {
                    that.displayBehaviorLetterHeadline = true;
                }
            }
        });
    }

    ngOnDestroy() {
    }

    ngAfterViewInit() {
        this.sharedService.updateIsPageLoaded(true);
        this.eFormHeadLinePermission = this.eFormService.eFormHeadLinePermission;
    }

    getOnlineRegistrationStatus() {
        if (this.userService.userType !== 1) {
            this.studentSummaryService.getOnlineRegistrationStatus(this.yearService.student360Year.Id).subscribe((response) => {
                if (response.ok) {
                    if (response.body == '' || response.body == 'Approved' || response.body == 'Submitted') {
                        this.displayORHeadline = false;
                    } else {
                        this.displayORHeadline = true;
                        this.onlineRegistrationStatus = response.body;
                    }
                }
            });
        }
    }

    getCourseRequestStatus() {
        if (this.userService.userType !== 1) {
            this.studentSummaryService.getCourseRequestStatus(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id).subscribe((response) => {
                if (response.ok) {
                    if (response.body == '' || response.body == 'Accepted') {
                        this.displayCourseRequestHeadline = false;
                    } else {
                        this.displayCourseRequestHeadline = true;
                    }
                }
            });
        }
    }

    getAnnouncements() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardAnnouncements(this.studentService.selectedStudent.Id, this.userService.currentUser.Id, schoolId, this.userService.userType, this.yearService.student360Year.Id).subscribe(response => {
            if (response.ok) {
                // Check for new announcements
                if (response.body.find(a => a.IsNewSinceLastLogin)) {
                    // If the user has not already seen the new announcement modal
                    if (!this.studentSummaryService.hasSeenNewAnnouncementModal) {
                        // Show Announcements Modal
                        // Filter out old announcements
                        response.body = response.body.filter(announcement => announcement.IsNewSinceLastLogin == true);
                        // Display Welcome Modal For First Time Users
                        this.displayWelcome();
                    }
                } else {
                    this.displayWelcome();
                }
            }
        });
    }

    getAnnouncementsPopup() {
        const lastLoginDate = moment(this.userService.currentUser.LastLoggedInDate, 'YYYY-MM-DDTHH:mm:ss.SSS');
        if (!moment().isSame(lastLoginDate, 'day')) {
            this.studentSummaryService.getStudentsNewAnnouncements(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(response => {
                if (response) {
                    const newAnnouncementsBody = response.filter(a => a.IsNewAnnouncement == true || a.ShowDaily == true);
                    if (!this.studentSummaryService.hasSeenNewAnnouncementModal && newAnnouncementsBody.length > 0) {
                        // Show Announcements Modal
                        this.dialog.open(NewAnnouncementsModalComponent, {
                            disableClose: true,
                            minHeight: '70%',
                            minWidth: '70%',
                            autoFocus: false,
                            data: newAnnouncementsBody
                        });
                    }
                }
            });
        }
    }

    eventViewClick(eventType: string) {
        if (eventType == 'discipline') {
            this.router.navigateByUrl('/student360/behavior');
        }
        if (eventType == 'onlineRegistration') {
            this.onlineRegService.getOnlineRegFamilies(false).subscribe(data => {
                if (data.length > 1) {
                    const dialogBox = this.dialog.open(MultipleFamiliesComponent, {
                        panelClass: 'tyl-mat-dialog',
                        data: { families: data },
                        disableClose: true
                    });
                    const subscription = dialogBox.afterClosed().subscribe(result => {
                        subscription.unsubscribe();
                        if (parseInt(result, 0) > 0) {
                            this.onlineRegService.isMultipleFamiliesPopupOpened = true;
                            this.router.navigateByUrl('/student360/onlineRegistration');
                        }
                    });
                } else if (data.length == 1) {
                    this.onlineRegService.isMultipleFamiliesPopupOpened = false;
                    this.onlineRegService.familyId = data[0].FamilyId;
                    this.onlineRegService.parentType = data[0].ParentType;
                    this.router.navigateByUrl('/student360/onlineRegistration');
                } else {
                    this.router.navigateByUrl('/student360/onlineRegistration');
                }
            });
        }
        if (eventType == 'courseRequests') {
            let routed = false;
            if (this.student360Service.allParentPortals) {
                const portal = this.student360Service.allParentPortals.filter(p => p.PortalName == 'Course Requests' && p.Student_ID == this.selectedStudent.Id)[0];
                if (portal != undefined) {
                    this.router.navigateByUrl('/student360' + portal.PortalDescription);
                    routed = true;
                }
            }
            if (!routed) {
                this.router.navigateByUrl('/student360/courseRequest');
            }
        }
        if (eventType == 'health') {
            const navigationExtras: NavigationExtras = {
                queryParams: {
                    'selectedTab': 'Health Visit Log'
                }
            };
            this.router.navigate(['/student360/health'], navigationExtras);
        }
        if (eventType == 'requiredEForms') {
            this.eFormService.initialS360eFormTab = 'required';
            this.router.navigateByUrl('/student360/eForms');
        }
        if (eventType == 'optionalEForms') {
            this.eFormService.initialS360eFormTab = 'optional';
            this.router.navigateByUrl('/student360/eForms');
        }
        if (eventType == 'studentDocument') {
            // this.eFormService.initialS360eFormTab = 'optional';
            this.router.navigateByUrl('/student360/studentDocuments');
        }

        if (eventType == 'studentDocumentBehaviorLetters') {
            const navigationExtras: NavigationExtras = {
                queryParams: {
                    'onlyBehaviorLettersDocument': true
                }
            };
            this.router.navigate(['/student360/studentDocuments'], navigationExtras);
        }

        if (eventType == 'studentDocumentAttLetters') {
            const navigationExtras: NavigationExtras = {
                queryParams: {
                    'onlyAttendanceLettersDocument': true
                }
            };
            this.router.navigate(['/student360/studentDocuments'], navigationExtras);
        }

        if (eventType == 'behaviorLetter') {
            this.router.navigateByUrl('student360/behavior?studentPortal=true');
        }
    }

    markEventsAsSeen(eventType: string) {
        this.studentSummaryService.markEventsAsSeen(this.selectedStudent.Id, this.userService.currentUser.MemberId, eventType, this.yearService.student360Year.Id, this.optionalInstanceIds, this.studentDocumentIds).subscribe(response => {
            if (response.ok) {
                this.getRecentEvents();
                if (eventType != 'BehaviorLetter') {
                    this.getStudentDocuments();
                }
            }
        });
    }

    checkEFormAvailable() {
        this.eFormsActivated = this.loginService.LoginSettings.ActivateEForms;

        if (this.eFormsActivated && this.yearService.student360Year.Id > 0) {
            this.eFormService.checkForAvailableEForms(true).subscribe(result => {
                this.requiredEFormAvailable = result.eFormsAvailable;
                this.optionalEFormAvailable = result.optionaleFormAvailable;
                this.optionalInstanceIds = result.instanceId;
                this.getRecentEvents();
            });
        } else {
            this.requiredEFormAvailable = 0;
            this.optionalEFormAvailable = 0;
            this.getRecentEvents();
        }
    }

    getRecentEvents() {
        if (this.selectedStudent) {
            this.studentSummaryService.getStudentRecentEvents(this.selectedStudent.Id, this.userService.currentUser.MemberId, this.yearService.student360Year.Id, this.optionalInstanceIds).subscribe(response => {
                if (response.ok) {
                    this.recentDisciplineEvents = response.body.filter(rde => rde.Type == 'Discipline')[0];
                    this.recentHealthEvents = response.body.filter(rde => rde.Type == 'Health')[0];
                    this.recentOptionalEFormEvents = response.body.filter(rde => rde.Type == 'OptionalEForms')[0];
                    this.recentBehaviorLetters = response.body.filter(rde => rde.Type == 'BehaviorLetter')[0];
                }
            });
            if (this.eFormsActivated && this.yearService.student360Year.Id > 0) {
                this.unmarkedOptionalEFormsEvents = this.optionalEFormAvailable > 0;
            }
        }
    }

    getStudentDocuments() {
        this.studentService.getStudentDocuments(this.selectedStudent.Id, this.yearService.student360Year.Id, false, true).subscribe(data => {
            this.studentDocuments = data;
            const currentDate = new Date();
            this.studentDocuments.forEach(obj => {
                this.studentDocumentIds += obj.DocumentId + ',';
            });
            currentDate.setDate(currentDate.getDate() - 8);
            this.studentDocuments = this.studentDocuments.filter(x => x.CreatedOn > currentDate);
            this.behaviorlatterStudentDocuments = this.studentDocuments.filter(x => x.Notes == 'Behavior Letter').length > 0;
            this.attendancelatterStudentDocuments = this.studentDocuments.filter(x => x.Notes == 'Attendance Letter').length > 0;;
        });
    }

    checkPortals(portals: Portal[]) {
        // Compare portals
        this.userService.cards = [];
        const studentId = (this.userService.currentUser.UserType != 1) ? this.selectedStudent.Id : 0;
        this.userPreferencesService.getUserPreferences(studentId, '/OneSISStudentSummaryAngular').subscribe(response => {
            if (response && response.length > 0 && response[0] != '') { // If saved preference for card state
                try {
                    const savedCards = JSON.parse(response[0]);
                    const commonCards = [];
                    // Compare the saved cards with the default cards, this is in the event that we remove cards
                    savedCards.forEach(sCard => {
                        // find the saved card in the default list
                        this.studentSummaryService.defaultCards.forEach(card => {
                            if (sCard.title == card.title) {
                                commonCards.push(sCard);
                            }
                        });
                    });
                    // Check the default card list for new cards
                    this.studentSummaryService.defaultCards.forEach(card => {
                        // Find the card in the saved cards
                        const c = savedCards.filter(sCard => sCard.title == card.title)[0];
                        if (!c) { // if not found, push the default card
                            commonCards.push(_.cloneDeep(card));
                        }
                    });
                    this.userService.cards = commonCards;
                } catch {
                    // Set the default card data upon a failure (usually to load JSON)
                    this.userService.cards = _.cloneDeep(this.studentSummaryService.defaultCards);
                }
            } else {
                // Set the default card data
                this.userService.cards = _.cloneDeep(this.studentSummaryService.defaultCards);
            }
            if (this.userService.userType == 1) { // If staff member
                // Filter out the portals based on group.
                const myStudentsGroup = this.portals.filter(p => p.GroupName == 'My Students');
                if (myStudentsGroup.length > 0) { // User is a teacher
                    portals = myStudentsGroup;
                } else { // user is an admin
                    portals = this.portals.filter(p => p.GroupName == 'Students');
                }
            }
            this.userService.cards.forEach((card) => {
                let portal;
                switch (card.title) {
                    case 'Announcements':
                        portal = portals.find((p) => p.PortalName == 'Announcements');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Attendance':
                        portal = portals.find((p) => p.PortalName == 'Attendance');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Assignments':
                        portal = portals.find((p) => p.PortalName == 'Assignments');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Current Grades':
                        portal = portals.find((p) => p.PortalName == 'Grades');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'District Defined Links':
                        portal = portals.find((p) => p.IsMyLinksTile == true);
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Fees & Billing':
                        portal = portals.find((p) => p.PortalName == 'Fees & Billing');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Meal Service Balance':
                        portal = portals.find((p) => p.PortalName == 'Meal Service');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Student Schedule':
                        portal = portals.find((p) => p.PortalName == 'Student Schedule');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Upcoming Events':
                        portal = portals.find((p) => p.PortalName == 'Calendar');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Calendar':
                        portal = portals.find((p) => p.PortalName == 'Calendar');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    // case 'Student Teams': // Staff card V10 Only
                    //     portal = portals.find((p) => p.PortalName == 'Activities and Teams');
                    //     if (portal) {
                    //         this.showCard(card, portal);
                    //     } else {
                    //         this.hideCard(card);
                    //     }
                    //     break;
                    // case 'Student Notes': // Staff card V10 Only
                    //     portal = portals.find((p) => p.PortalName == 'Student Notes');
                    //     if (portal) {
                    //         this.showCard(card, portal);
                    //     } else {
                    //         this.hideCard(card);
                    //     }
                    //     break;
                    case 'Behavior': // Staff card
                        portal = portals.find((p) => p.PortalName == 'Behavior');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Programs and Services': // Staff card
                        portal = false;
                        portal = portals.find((p) => p.PortalName == 'Programs and Services');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Student Details': // Staff card
                        portal = portals.find((p) => p.PortalName == 'Student Details');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Enrollment': // Staff card
                        // Disable in v9 for Jan release - Lance
                        portal = portals.find((p) => p.PortalName == 'Student Details');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Contacts': // Staff card
                        // Disable in v9 for Jan release - Lance
                        portal = portals.find((p) => p.PortalName == 'Student Details');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Attendance History': // Staff card
                        portal = portals.find((p) => p.PortalName == 'Attendance');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                    case 'Student Schedule - Staff View': // Staff card
                        portal = portals.find((p) => p.PortalName == 'Student Schedule');
                        if (portal) {
                            this.showCard(card, portal);
                        } else {
                            this.hideCard(card);
                        }
                        break;
                }
            });
            if (this.userService.cards.find(a => a.title == 'Communications Log') && this.userService.cards.find(a => a.title == 'Communications Log').component == '') {
                this.userService.cards.find(a => a.title == 'Communications Log').component = 'communicationLogCard';
            }
            this.cardContainer.filterCards(this.userService.cards);
        });
    }

    hideCard(card) {
        card.display = 'Off';
        card.showInSettings = false;
    }

    showCard(card, portal) {
        card.disabled = portal.Disabled;
        card.disabledMessage = portal.DisabledMessage;
        card.showInSettings = true;
    }

    loadStudentInfo(studentId: number) {
        this.selectedStudent = this.studentService.students.find(function (student) {
            return student.Id == studentId;
        });
    }

    displayWelcome() {
        if (!this.userService.currentUser.PreviousAngularLogin) {
            if (this.userService.currentUser.UserType != 1) {
                // Wrapped in a timeout to avoid change detection errors
                setTimeout(() => {
                    this.dialog.open(WelcomeModalComponent, {
                        disableClose: true,
                        minHeight: '50%',
                        minWidth: '50%',
                        autoFocus: false
                    });
                }, 1);
            }
            this.userService.currentUser.PreviousAngularLogin = true;
        }
    }

    settingsClick() {
        // Open the Side menu
        this.dialog.open(SettingsMenuModalComponent, {
            minWidth: '430px',
            width: '25%',
            minHeight: '100%',
            autoFocus: false,
            position: { right: '0' }
        }).afterClosed().subscribe(result => {
            if (result == 'Saved') {
                this.cardContainer.filterCards(this.userService.cards);
                // Save the preferences
                const json: string[] = [];
                json.push(JSON.stringify(this.userService.cards));
                const studentId = (this.userService.currentUser.UserType != 1) ? this.studentService.selectedStudent.Id : 0;
                this.userPreferencesService.saveUserPreferences(studentId, '/OneSISStudentSummaryAngular', json, 0, '').subscribe(response => {
                }, err => {
                    // On Error
                    console.log(err);
                });
            }
        });
    }

    hasPrivilege(type: string) {
        // Check the parent assigned portals to see if the user has the privilege to see the event
        if (this.student360Service.parentAssignedPortals) {
            if (type == 'Discipline') {
                if (this.student360Service.parentAssignedPortals.find(p => p.PortalName == 'Behavior')) {
                    return true;
                }
            }
            if (type == 'Health') {
                if (this.student360Service.parentAssignedPortals.find(p => p.PortalName == 'Health')) {
                    return true;
                }
            }
            if (type == 'Online Registration') {
                if (this.student360Service.parentAssignedPortals.find(p => p.PortalName == 'Online Registration')) {
                    return true;
                }
            }
            if (type == 'Course Requests') {
                if (this.displayCourseRequestHeadline) {
                    return true;
                }
            }
        }
    }

    getOnlinePaymentConfiguration() {
        this.studentService.getOnlinePaymentConfiguration().subscribe(result => {
            this.onlinePaymentConfiguration = result;
            //  Load onlinePaymentConfiguration data into Online Payment Service for child components to access
            this.studentService.onlinePaymentConfiguration = this.onlinePaymentConfiguration;
        });
    }

    getCheckInOutButtnSettings(studentId: number, yearId: number) {
        this.studentSummaryService.getCheckInOutButtonSettings(studentId, yearId).subscribe(settings => {
            if (this.userService.currentUser.UserType == 2) {
                this.enableCheckInOut = settings.AllowParentEnterCheckInOut;
                this.enableAbsentNotice = settings.AllowParentEnterAbsentNotice;
            }
            else if (this.userService.currentUser.UserType == 3) {
                this.enableCheckInOut = settings.AllowStudentEnterCheckInOut;
                this.enableAbsentNotice = settings.AllowStudentEnterAbsentNotice;
            }
        });
    }

    checkInOutButtonClick(studentId: number) {
        this.studentSummaryService.getCheckInOutSubmissionRequest(studentId).subscribe(request => {
            if (request != undefined && request != null && request.Id > 0) {
                this.checkInOutSubmissionRequest = request;
            }
            else {
                this.checkInOutSubmissionRequest = new CheckInOutSubmissionRequest;
                this.checkInOutSubmissionRequest.StudentId = studentId;
            }

            const dialogBox = this.dialog.open(CheckInOutSubmissionRequestModalComponent, {
                disableClose: true,
                minWidth: '60vw',
                maxWidth: '60vw',
                minHeight: '65vh',
                maxHeight: '80vh',
                data: {
                    checkInOutRequest: this.checkInOutSubmissionRequest
                }
            });
        });
    }

    absentNoticeButtonClick(studentId: number) {
        this.studentSummaryService.getAbsentNoticeByStudentId(studentId).subscribe(request => {
            let absentNotice: AbsentNotice;

            if (request != undefined && request != null && request.Id > 0) {
                absentNotice = request;
            }
            else {
                absentNotice = new AbsentNotice;
                absentNotice.Id = 0;
                absentNotice.StudentId = studentId;
                absentNotice.SubmittedPeopleId = 0;
                absentNotice.Reason = '';
                absentNotice.Status = 'Submitted';
            }

            this.dialog.open(AbsentNoticeSubmissionModalComponent, {
                disableClose: true,
                minWidth: '60vw',
                maxWidth: '60vw',
                minHeight: '65vh',
                maxHeight: '80vh',
                data: {
                    absentNotice: absentNotice
                }
            });
        });
    }
}
